'use client';

import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
interface ReduxProviderProps {
  children: ReactNode;
}
const ReduxProvider = ({
  children
}: ReduxProviderProps) => <Provider store={store} data-sentry-element="Provider" data-sentry-component="ReduxProvider" data-sentry-source-file="ReduxProvider.tsx">
    <PersistGate loading={null} persistor={persistor} data-sentry-element="PersistGate" data-sentry-source-file="ReduxProvider.tsx">
      {children}
    </PersistGate>
  </Provider>;
export default ReduxProvider;